import db from '@/store/db';
import moment from 'moment';
import log from '@/logger';

export default {
  prepareCompanyEntity(values) {
    const company = {
      companyName: '',
      type: 'Company',
      registrationNumber: '',
      vatNumber: '',
      address: {
        street: '',
        zipCode: '',
        city: '',
      },
      email: '',
      phone: '',
      mainBusiness: [],
      usedBefore: false,
      doNotUse: false,
      comment: '',
      projects: [],
      role: '',
      registrationLinks: [],
      ...(typeof values === 'object' && values != null ? values : {}),
    };

    if (!company.createdAt) {
      company.createdAt = moment().format();
    }

    return company;
  },

  async createCompany(values) {
    const newCompany = this.prepareCompanyEntity(values);
    const doc = await db.organisationDb.post(newCompany);
    newCompany._id = doc.id;
    newCompany._rev = doc.rev;

    return newCompany;
  },

  async saveCompany(company) {
    const isUpdate = !!company._id;
    const { id, rev } = await (isUpdate ? db.organisationDb.put(company) : db.organisationDb.post(company));

    return isUpdate ? { _rev: rev } : { _id: id, _rev: rev };
  },

  async fetchCompanies() {
    try {
      const result = await db.organisationDb.query('companyList', { include_docs: true });
      const populated = {};
      result.rows.forEach(({ doc }) => {
        const company = this.upgradeCompanyDocument(doc);
        populated[company._id] = company;
      });

      return populated;
    } catch (error) {
      log.error('Unable to load companies', error);
    }
  },

  // Conversion for backwards compatibility
  upgradeCompanyDocument(doc) {
    const company = this.prepareCompanyEntity(doc);
    if (!Array.isArray(company.mainBusiness)) {
      if (company.mainBusiness === '') {
        company.mainBusiness = [];
      } else {
        company.mainBusiness = [company.mainBusiness];
      }
    }
    return company;
  },
};



// WEBPACK FOOTER //
// ./src/store/company/companyApi.js